import { motion } from "framer-motion";
import { steps } from "@/data/site";
import Reveal from "./Reveal";

export default function ProcessTimeline() {
  return (
    <div data-testid="process-timeline">
      {/* Desktop: horizontal */}
      <div className="relative hidden lg:block">
        <div className="absolute left-0 right-0 top-6 h-px bg-[#0B1F3A]/10" />
        <motion.div
          className="absolute left-0 top-6 h-px origin-left bg-[#A87B1F]"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.8, ease: "easeInOut" }}
          style={{ right: 0 }}
        />
        <div className="grid grid-cols-5 gap-8">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.15}>
              <div className="relative pt-0">
                <span className="relative z-10 inline-flex h-12 w-12 items-center justify-center rounded-full border-2 border-[#A87B1F] bg-white font-display text-sm font-bold text-[#A87B1F]" data-testid={`timeline-step-${s.n}`}>
                  {s.n}
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-[#0B1F3A]">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#667085]">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      {/* Mobile / tablet: vertical */}
      <div className="relative lg:hidden">
        <div className="absolute bottom-0 left-6 top-0 w-px bg-[#0B1F3A]/10" />
        <div className="space-y-10">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className="relative pl-20">
              <span className="absolute left-0 top-0 inline-flex h-12 w-12 items-center justify-center rounded-full border-2 border-[#A87B1F] bg-white font-display text-sm font-bold text-[#A87B1F]">
                {s.n}
              </span>
              <h3 className="font-display text-lg font-bold text-[#0B1F3A]">{s.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-[#667085]">{s.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
